//#region src/staleChunk/isStaleChunkError.ts
var e = [
	/failed to fetch dynamically imported module/i,
	/error loading dynamically imported module/i,
	/importing a module script failed/i,
	/loading chunk [\w-]+ failed/i
];
function t(t) {
	if (!t) return !1;
	if (t instanceof Error) return t.name === "ChunkLoadError" ? !0 : e.some((e) => e.test(t.message));
	let n = typeof t == "string" ? t : typeof t.message == "string" ? t.message : "";
	return n !== "" && e.some((e) => e.test(n));
}
//#endregion
export { t as isStaleChunkError };
